import { CheckboxTableCell } from './CheckboxTableCell';

export default CheckboxTableCell;
